function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import _AlertWarningFilledIcon from "@adsk/alloy-react-icon/es/lib/AlertWarningFilledIcon";
import _styled from "styled-components";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@adsk/alloy-react-avatar';
import Button, { LinkButton } from '@adsk/alloy-react-button';
import { useControlled } from '@adsk/alloy-react-helpers';
import { useLocale } from '@adsk/alloy-react-locale';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import DefaultCommentInput from './layout/DefaultCommentInput';
/**
 * A Comment field component showing user avatar, a text input, and form buttons
 */
var CommentField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var style = _ref.style,
    className = _ref.className,
    inputValue = _ref.value,
    user = _ref.user,
    submitting = _ref.submitting,
    error = _ref.error,
    maxLength = _ref.maxLength,
    onChange = _ref.onChange,
    onCancel = _ref.onCancel,
    onSubmit = _ref.onSubmit,
    _ref$renderInput = _ref.renderInput,
    renderInput = _ref$renderInput === void 0 ? function (props) {
      return /*#__PURE__*/React.createElement(DefaultCommentInput, props);
    } : _ref$renderInput;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocus = _useState2[1];
  var _useControlled = useControlled('', inputValue, onChange),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    setValue = _useControlled2[1];
  var _useLocale = useLocale(function (_ref2) {
      var locale = _ref2.locale;
      return require("./i18n/".concat(locale, ".json"));
    }),
    T = _useLocale.T;
  var handleSubmit = useCallback(function () {
    if (value) {
      onSubmit(value);
    }
  }, [value, onSubmit]);
  var handleCancelClick = useCallback(function () {
    onCancel && onCancel();
  }, [onCancel]);
  var handleBlur = useCallback(function (event) {
    if (!value && !error) {
      event === null || event === void 0 ? void 0 : event.preventDefault();
      setFocus(undefined);
    }
  }, [error, value]);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    ref: ref,
    $_css: [{
      display: 'flex'
    }, style]
  }, /*#__PURE__*/React.createElement(Avatar, {
    image: user.imageUrl,
    name: user ? user.name : undefined
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      marginLeft: '14px'
    }
  }, renderInput({
    value: value,
    focused: focused,
    error: error,
    maxLength: maxLength,
    disabled: submitting,
    onBlur: handleBlur,
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onChange: function onChange(newValue) {
      return setValue(newValue);
    },
    style: {
      width: '100%',
      minHeight: 68,
      color: theme.colors.charcoal900
    }
  }), (focused || error || submitting) && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: error ? '5px' : '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: error ? 'flex-start' : 'flex-end'
    }
  }, error && /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread({}, theme.typography.bodySmall), {}, {
      color: theme.colors.red700,
      display: 'flex',
      alignItems: 'center'
    })
  }, /*#__PURE__*/React.createElement(_AlertWarningFilledIcon, {
    size: 16,
    style: {
      color: theme.colors.red500,
      marginRight: theme.spacing.xSmall
    }
  }), /*#__PURE__*/React.createElement("span", null, error)), !error && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LinkButton, {
    disabled: !value || submitting,
    onClick: handleCancelClick,
    size: Button.SIZES.SMALL,
    style: {
      marginRight: theme.spacing.small
    },
    "data-testid": "CommentField__cancel"
  }, T.translate('CANCEL')), /*#__PURE__*/React.createElement(Button, {
    variant: Button.VARIANTS.PRIMARY,
    disabled: !value,
    loading: submitting,
    size: Button.SIZES.SMALL,
    style: submitting ? {
      backgroundColor: theme.colors.adskBlue300
    } : {},
    onClick: handleSubmit,
    "data-testid": "CommentField__submit"
  }, T.translate('SUBMIT'))))));
});
CommentField.displayName = 'CommentField';
CommentField.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The value of the comment field */
  value: PropTypes.string,
  /** The current user object */
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string
  }).isRequired,
  /** Is submitting comment **/
  submitting: PropTypes.bool,
  /** An error message. When set triggers error state and shows it in a label **/
  error: PropTypes.string,
  /** Max characters allowed (activates character count) */
  maxLength: PropTypes.number,
  /* Triggers when comment input field is changed **/
  onChange: PropTypes.func,
  /* Triggers when submit button is clicked **/
  onSubmit: PropTypes.func.isRequired,
  /** Triggers when clear button is clicked **/
  onCancel: PropTypes.func,
  /** Render custom input component. Props ({ onBlur, onChange, onFocus, disabled, error, value }) */
  renderInput: PropTypes.func
};
export default CommentField;
var _StyledDiv = _styled("div").withConfig({
  displayName: "CommentField___StyledDiv",
  componentId: "sc-1g4sy9r-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=CommentField.js.map